import { render, staticRenderFns } from "./specificRequirementsSelection.vue?vue&type=template&id=d64debde&scoped=true&"
import script from "./specificRequirementsSelection.vue?vue&type=script&lang=js&"
export * from "./specificRequirementsSelection.vue?vue&type=script&lang=js&"
import style0 from "./specificRequirementsSelection.vue?vue&type=style&index=0&id=d64debde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64debde",
  null
  
)

export default component.exports